<template>
<div>

<el-tabs v-model="activeName" tab-position="left" height="auto" @tab-click="tabClick">
    <el-tab-pane label="数据集" name="first">
      <el-table
          v-loading="loading"
          :data="answerList"
          style="width:100%" stripe fit empty-text>
          <!-- <el-table-column
            fixed
            prop="scope.row.starflag"
            label=""
            width="40">
            <template slot-scope="scope">
              <el-link v-if="scope.row.starflag=='1'" icon="el-icon-star-on" @click.stop="flagStar(scope.row.answerid)" :underline="false" style="font-size:20px;padding-right:8px;color:#E6A23C;"></el-link>
              <el-link v-if="scope.row.starflag!='1'" icon="el-icon-star-off" @click.stop="flagStar(scope.row.answerid)" :underline="false" style="font-size:20px;padding-right:8px;"></el-link>
            </template>
          </el-table-column> -->
          <el-table-column fixed label="#" type="index" show-overflow-tooltip width="50">
          </el-table-column>
          <el-table-column
            fixed
            prop="submitteddate"
            label="日期"
            width="200">
            <template slot-scope="scope" v-if="scope.row.submitteddate ||'' != ''">
              {{scope.row.submitteddate}}<br>
              <span style="color:#aabbcc">{{$moment(scope.row.submitteddate).fromNow()}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="form.category =='SUBJECT'"
            fixed
            prop="unitsubjectname"
            label="患者"
            width="80">
            <template slot-scope="scope">
              

              <el-link @click="goToSubject(scope.row.subjectid)" type="primary" :underline="false">
                {{scope.row.unitsubjectnumber}}<br>
                {{scope.row.unitsubjectname}}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column 
          v-for="question in questions"

            :label="question.caption">
            <template slot-scope="scope">
                <template v-if="question.datatype=='xml'">
                  <el-popover
                    placement="right"
                    width="400"
                    trigger="click">
                    <template>
                          <ul v-if="question.inline=='1'" style="list-style:none;">
                            <li v-for="field in question.fields" style="height:35px;">
                              <el-checkbox :checked='getChecked(scope.row[question.name], field.name)' disabled>{{field.caption}}</el-checkbox>
                            </li>
                          </ul>

                          <el-table v-if="question.inline=='0'" :data="scope.row[question.name] ||[]" border height="300">
                            <el-table-column 
                            v-for="field in question.fields"
                            :prop="field.name"
                            :label="field.caption">
                                <template slot-scope="scope">
                                    <template v-if="field.datatype==='enum'">
                                      <template v-for="eu in field.enum">
                                        <span v-if="eu.name==scope.row[field.name]">{{eu.caption}}</span>
                                      </template>
                                    </template>
                                    <span v-if="field.datatype=='string' || field.datatype=='int'">{{ scope.row[field.name] || '' }}</span>
                                </template>
                            </el-table-column>
                          </el-table>
                    </template>
                    <template v-if="question.inline=='1'">
                      <el-link slot="reference">{{getAllChecked(scope.row[question.name], question)}}</el-link>
                    </template>
                    <i v-if="question.inline!='1'" class="el-icon-more" slot="reference"></i>
                  </el-popover>
                </template>
              <template v-if="question.datatype==='enum'">
                <template v-for="item in question.enum">
                  <span v-if="item.name==scope.row[question.name]">{{item.caption}}</span>
                </template>
              </template>
              <span v-if="question.datatype=='string' || question.datatype=='int'">{{ scope.row[question.name] || '' }}</span>
            </template>

          </el-table-column>
          
          <el-table-column
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button @click="showAnswer(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-drawer
          title="我是标题"
          size = "50%"
          :visible.sync="drawer"
          :with-header="false">
          <iframe ref="iframe" :src="viewUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
        </el-drawer>

        <el-drawer
          title="我是标题"
          size = "50%"
          :visible.sync="drawerSmartTable"
          :with-header="false">
          <span>SmartTable</span>
        </el-drawer>

    </el-tab-pane>
    <el-tab-pane label="折线图" name="second">
      <el-radio-group v-model="radio1" @change="draw1">
        <el-radio v-for="question in questions" v-if="question.datatype!='xml' && question.datatype !='enum'" :label="question.name" :key="question.name">{{question.caption}}</el-radio>
      </el-radio-group>
      
      <div ref="myChart" style="width:800px;height:400px;"></div>
    </el-tab-pane>
    <el-tab-pane label="关联患者" name="subjectchart" v-if="form.category =='SUBJECT'">
      <div ref="myChartSubject" style="width:800px;height:400px;"></div>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        radio1: '',
        activeName: 'first',
        myChart:null,
        drawerSmartTable: false,
        drawer: false,
        questions: [],
        answerList: [],
        loading:true,
        viewUrl: '',
        form: {
          formid: this.$route.query['id'],
          category:this.$route.query['category'],
        },

        rules: {
        }
      }
    },
    computed: {
      
    },
    mounted() {
      this.loadQuestions();
    },
    methods: {
      tabClick (tab) {
        if(tab.name == 'second'){
          if(this.radio1 != '') {
            this.getChart1();
          }
        }
        else if(tab.name == 'subjectchart'){
          this.getChartSubject(); 
        }
      },
      draw1() {
        this.getChart1();
      },
      getChart1() {
        var myChart = this.$echarts.init(this.$refs.myChart)

        var chartData = this.getChartData(this.answerList.reverse());
        console.log(chartData);
        myChart.setOption(
        {
          grid:{
            y2:150, //增加X轴标签的高度
          },
          toolbox: {
              feature: {
                restore: {},
              }
          },
          legend: {
              data: chartData["legend"],
              type: 'scroll',
              left :10,
              top: 10
          },
          tooltip: {
              trigger: 'axis'
          },
          dataZoom: [
            {
                type:'slider',
                show: true,
                realtime: true,
                startValue: chartData["x"].length-15,
                endValue: chartData["x"].length,
            },
            {
                type:'inside',
                show: true,
                realtime: true,
                startValue: chartData["x"].length-15,
                endValue: chartData["x"].length,
            }
          ],
          xAxis: {
              type: 'category',
              data: chartData["x"],
              axisLabel:{
                
                interval:0,
                rotate:40,
              },
          },
          yAxis: {
              type: 'value'
          },
          series: chartData["series"]
        });
      },
      getLegend(){
        var lg = [];
        this.answerList.reverse().forEach(item => {
          xs.push(item.unitsubjectname);
        });

        return xs;
      },

      getChartData(array){
        let chartData = {}

        //按SubjectID分组
        let groups={}
        array.forEach(o=>{
          let group = JSON.stringify(o.subjectid)
          groups[group] = groups[group] || []
          groups[group].push(o)
        });
        
        //图例
        //let lengend = Object.keys(groups).map(item=> (groups[item][0].unitsubjectname || '' !='')?groups[item][0].unitsubjectname:'无');
        
        var ys = [];
        var xs = [];
        array.forEach(item => {
          //x轴
          xs.push(item.submitteddate);

          //y轴准备
          Object.keys(groups).forEach(group => {
            let findgroup = (groups[group] || []).find(groupitem => {return groupitem.submitteddate == item.submitteddate})
            ys[group] = ys[group] || []
            if(findgroup != undefined){
              ys[group].push(findgroup[this.radio1] || "")
            }else{
              ys[group].push("")
            }
          })

        });

        let legend=[];
        let series=[];
        Object.keys(groups).forEach(group => {
          let ser = {}
          ser.name = groups[group][0].unitsubjectname;
          ser.type = "line";
          ser.data = ys[group];
          series.push(ser);

          legend.push(groups[group][0].unitsubjectname);
        })
     

        chartData["legend"] = legend;
        chartData["x"] = xs;
        chartData["series"] = series;

        return chartData;
        
      },

      // getChart1_X() {
      //   //console.log(this.groupBy(this.answerList.reverse(),item=>item.unitsubjectname + '_' + item.subjectid))
      //   var xs = [];
      //   this.answerList.reverse().forEach(item => {
      //     xs.push(item.submitteddate);
      //   });

      //   return xs;
      // },

      // getChart1_Y() {
      //   var ys = [];
      //   this.answerList.reverse().forEach(item => {
      //     //console.log(item.unitsubjectname,item.submitteddate + "..." + item[this.radio1] +'--')
      //     ys.push(item[this.radio1]);
      //   });

      //   return ys;
      // },
      getAllChecked(r,q){
        r = r || [];
        if(r.length == 0) return '';

        var r1 = r[0];

        var strs = [];
        for(var i=0; i<q.fields.length; i++){
          if((r1[q.fields[i].name] || "0") == "1")
          {
              strs.push(q.fields[i].caption);
          }
        }
        return strs.join('/');
      },
      getChecked(r, v){
        r = r || [];
        if(r.length == 0) return false;
        
        return (r[0][v] || "0") == "1";
      },
      loadQuestions() {
        this.loading = true;
        //caption
        this.$http.get('form/questions',{params:{id:this.form.formid}}).then((res) => {
            if(!res) return;
            this.questions = res.data.list;
                this.loadList();
            }); 
      },
      loadList() {
          this.$http.get('form/datagrid',{params:{id:this.form.formid}}).then((res) => {
            if(!res) return;
            this.answerList = res.data.list;
            this.loading = false;
            });                                                  
      },
      showAnswer(row, col, evt) {
        
        this.$http.get('form/showanswer',{params:{id:row.answerid,subjectid:row.subjectid}}).then((res) => {
            if(!res) return;
            this.drawer = true;
            

            var view = res.data.view;
            window.formViewHtml = view;
            this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
            }); 
      },
      showSmartTable(row, col, evt) {
        
        this.drawerSmartTable = true;
      },


      //关联患者
      getChartSubject(){
        let myChart2 = this.$echarts.init(this.$refs.myChartSubject)
        
        
        let chartData = [];

        //分组
        let resultArray = [];
        this.answerList.reverse().forEach(item => {
          let idx = resultArray.findIndex(val => {
              return val.id === item.subjectid  //分组条件
          });
          let resultMap = idx !== -1 ? resultArray[idx] : {};
          if (Object.keys(resultMap).length === 0) {
              let groupbylist = [];
              groupbylist.push(item);
              resultMap['id'] = item.subjectid;
              resultMap['name'] = item.unitsubjectnumber + ' ' + item.unitsubjectname;
              resultMap['groupbylist'] = groupbylist;
              resultArray.push(resultMap);
          } else {
              let resultObj = resultArray[idx] || {};
              let array = resultObj['groupbylist'];
              array.push(item);
          }
        });

        let chartX = [];
        let chartY =[];
        resultArray.forEach(item => {
          chartX.push(item["name"]);
          chartY.push(item["groupbylist"].length)
        });

        let option = {
            xAxis: {
                type: 'category',
                data: chartX,
                axisLabel:{
                  interval:0,
                }
                
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: chartY,
                type: 'bar',
                showBackground: false,
                label:{
                  show:true,
                  position:'top',
                  formatter:'{c}',
                }
            }]
        };

        myChart2.setOption(option);
      },



      //打开患者个人窗口
      goToSubject(subjectid)
      {
        let {href}= this.$router.resolve({
          path: "/subject/forminput",   // 这里写的是要跳转的路由地址
          query: {id:subjectid}  // 这里写的是页面参数
        });
        window.open(href, '_blank');
      },


      groupBy(array,fn){
        let groups={}

        array.forEach(o=>{
          
          let group = JSON.stringify(fn(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })

        return Object.keys(groups).map(group => groups[group])
      }

    } 
  }
</script>

<style scoped>
iframe {
  width:100%;
  height:100%;
}
</style>